// extracted by css-extract-rspack-plugin
export default {"buyerTable":"s56OzvAu9W06LcgK__buyerTable___"};